import moment from 'moment'

export default {
  methods: {
    getStatus (item) {
      let status = ''
      const today = moment().format('YYYY-MM-DD')
      if (parseInt(item.rfq_status) === 1 || parseInt(item.contract_status) === 1) {
        status = 'Quotation Available'
      } else if (parseInt(item.rfq_status) === 8 || parseInt(item.contract_status) === 8) {
        status = 'Validating'
      } else if (parseInt(item.rfq_status) === 10 || parseInt(item.rfq_status) === 0 || parseInt(item.contract_status) === 10 || parseInt(item.contract_status) === 0) {
        status = 'Rejected'
      } else if ((parseInt(item.contract_status) === 3 && today <= moment(item.duration_end).format('YYYY-MM-DD'))) {
        status = 'On Going'
      } else if (parseInt(item.rfq_status) === 3 || parseInt(item.contract_status) === 3) {
        status = 'Completed'
      } else {
        status = 'Waiting for Bid'
      }
      return status
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getters/status-bid.js